import adminApiClient from './api.admin';
import ADMIN_API_ENDPOINTS from './endpoints.admin';
class AdminUsersService {
    async list() {
        // El endpoint usa GET para obtener la lista
        return adminApiClient.get(ADMIN_API_ENDPOINTS.USERS.BASE);
    }
    async get(id) {
        return adminApiClient.get(ADMIN_API_ENDPOINTS.USERS.BY_ID(id));
    }
    async create(payload) {
        return adminApiClient.post(ADMIN_API_ENDPOINTS.USERS.BASE, payload);
    }
    async update(id, payload) {
        // El endpoint de actualización usa POST
        return adminApiClient.put(ADMIN_API_ENDPOINTS.USERS.UPDATE(id), payload);
    }
    async remove(id) {
        return adminApiClient.delete(ADMIN_API_ENDPOINTS.USERS.BY_ID(id));
    }
    async toggleStatus(id) {
        // El endpoint usa PUT para cambiar el estado
        return adminApiClient.put(ADMIN_API_ENDPOINTS.USERS.TOGGLE_STATUS(id));
    }
}
export const adminUsersService = new AdminUsersService();
export default adminUsersService;
